/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import Validators from 'shared/validators';
import { mobileNumberFormat } from 'shared/modifiers';

export class LocationDefaults {

    title = '';
    description = '';
    contactname = '';
    email = '';
    phone = '';
    website = '';
    country = '';
    state = '';
    city = '';
    zip = '';
    about = '';
    timezone = '';
    paypalemail = '';
    googlecode = '';
    fbpixel = '';
    autosku = false;
    applytaxonbp = false;
    // isshippable = false;
    sendinvoicecopy = false;
    invoiceccemail = '';
    isautodebit = false;
    locationstatecode = '';
    locationcode = '';
    auctioneerlicense = '';
    shippingsaintaccountnumber = '';
    shippingsaint = 0;

    constructor(data) {
        if (data) {
            this.title = data['title'] || this.title;
            this.description = data['description'] || this.description;
            this.contactname = data['contactname'] || this.contactname;
            this.email = data['email'] || this.email;
            this.phone = mobileNumberFormat(data['phone']) || mobileNumberFormat(this.phone);
            this.website = data['website'] || this.website;
            this.country = data['country'] || this.country;
            this.state = data['state'] || this.state;
            this.city = data['city'] || this.city;
            this.zip = data['zip'] || this.zip;
            this.about = data['about'] || this.about;
            this.timezone = data['timezone'] || this.timezone;
            this.paypalemail = data['paypalemail'] || this.paypalemail;
            this.googlecode = data['googlecode'] || this.googlecode;
            this.fbpixel = data['fbpixel'] || this.fbpixel;
            this.autosku = data['autosku'] || this.autosku;
            this.applytaxonbp = data['applytaxonbp'] || this.applytaxonbp;
            // this.isshippable = data["isshippable"] || this.isshippable;
            this.sendinvoicecopy = data["sendinvoicecopy"] || this.sendinvoicecopy;
            this.invoiceccemail = data['invoiceccemail'] || this.invoiceccemail;
            this.isautodebit = data['isautodebit'] || this.isautodebit;
            this.locationstatecode = data['locationstatecode'] || this.locationstatecode;
            this.locationcode = data['locationcode'] || this.locationcode;
            this.auctioneerlicense = data['auctioneerlicense'] || this.auctioneerlicense;
            this.shippingsaintaccountnumber = data['shippingsaintaccountnumber'] || this.shippingsaintaccountnumber;
            this.shippingsaint = data['shippingsaint'] || this.shippingsaint;
        }
    }
}

export const LocationValidators = {
    title: [Validators.required(), Validators.maxLength(60)],
    description: [Validators.required(), Validators.maxLength(250)],
    contactname: [Validators.required(), Validators.maxLength(45)],
    email: [Validators.required(), Validators.email(), Validators.maxLength(45)],
    phone: [Validators.required(), Validators.maxLength(45), Validators.mobile()],
    website: [Validators.required(), Validators.maxLength(80), Validators.websiteUrl()],
    country: [Validators.required()],
    state: [Validators.required()],
    city: [Validators.required()],
    zip: [Validators.required(), Validators.equalToLength(5)],
    about: [Validators.required(), Validators.maxLength(500)],
    timezone: [Validators.required()],
    paypalemail: [Validators.required(), Validators.maxLength(80), Validators.email()],
    googlecode: [Validators.maxLength(45)],
    fbpixel: [Validators.maxLength(45)],
    autosku: [],
    applytaxonbp: [],
    // isshippable: [],
    sendinvoicecopy: [],
    invoiceccemail: [],
    isautodebit: [],
    locationstatecode: [],
    locationcode: [],
    auctioneerlicense: [],
    shippingsaintaccountnumber: [],
    shippingsaint: [],
};
